import { defineStore, storeToRefs } from 'pinia';
import { reactive, ref, watch } from 'vue';
import type { Ref } from 'vue';
import { useNuxtApp } from '#imports';
import { useUserStore } from './user';
import { CART_COOKIE_NAME } from '@/resources/helpers';

export const useCheckoutStore = defineStore('checkout', () => {
  const userStore = useUserStore();
  const { user } = storeToRefs(userStore);
  const { $logger } = useNuxtApp();

  const checkoutLoading: Ref<boolean> = ref(false);
  const error: Ref<boolean> = ref(false);
  const paymentMethodsLoading: Ref<boolean> = ref(false);
  const paymentMethods: Ref<Record<string, any>> = ref({});
  const shippingMethods: Ref<Record<string, any>> = ref({});

  const getCartId = () => localStorage.getItem(CART_COOKIE_NAME);

  async function getPaymentMethods() {
    paymentMethodsLoading.value = true;
    const cartId = getCartId();
    if (cartId) {
      try {
        const { result } = await $fetch('/api/checkout/getPaymentMethods', {
          query: {
            cartId
          }
        });
        paymentMethods.value = result.filter((paymentMethod: any) => paymentMethod.code !== 'mollie-sofort');
      } catch (err) {
        paymentMethodsLoading.value = false;
        $logger.error('error in  loading payment methods', err);
      } finally {
        paymentMethodsLoading.value = false;
      }
    }
  }

  async function getShippingMethods() {
    const cartId = getCartId();
    if (cartId) {
      try {
        const { result } = await $fetch('/api/checkout/getShippingMethods', {
          query: {
            cartId,
            countryId: personalDetails.countryId
          }
        });

        shippingMethods.value = result;
      } catch (err) {
        $logger.error('error in  loading shipping methods', err);
      }
    }
  }



  const personalDetails = reactive({
    notes: undefined,
    firstName: undefined,
    lastName: undefined,
    company: undefined,
    countryId: 'DE',
    streetAddress: undefined,
    apartmentNumber: undefined,
    city: undefined,
    email: undefined,
    state: undefined,
    region_id: 0,
    zipCode: undefined,
    phoneNumber: undefined,
    taxId: undefined,
    paymentMethod: 'mollie-creditcard',
    postcode: undefined,
    country_code: undefined
  });

  watch(user, () => {
    if (user.value) {
      const userAddress = user.value.default_shipping > 0
        ? user.value.addresses.find((address) => address.id === user.value.default_shipping)
        : user.value.adresses?.[0]

      personalDetails.email = user.value.email;
      personalDetails.firstName = user.value.firstname;
      personalDetails.lastName = user.value.lastname;
      personalDetails.phoneNumber = user.value.phonenumber;
      personalDetails.city = userAddress?.city;
      personalDetails.streetAddress = userAddress?.street;
      personalDetails.postcode = userAddress?.postcode;
      personalDetails.country_code = userAddress?.country_code;
    }
  });

  return {
    getCartId,
    personalDetails,
    checkoutLoading,
    error,
    getPaymentMethods,
    paymentMethodsLoading,
    paymentMethods,
    shippingMethods,
    getShippingMethods
  };
});
